module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-1.14e7ee4b.mp3";